import { indexedDB, DashBoard as DashBoardTable, DashBoardItem } from 'shared/indexedDb'
import { DashBoardData, DashBoardItemData } from 'features/dashBoard/types'

import { ApiAccess } from 'features/session/types'
import { GetSelfUserProfile, PostSelfUserProfile } from 'interface/user'
import { DashBoardProfileResult, GetDashBoardProfile } from 'interface/dashBoardProfile'

export const SaveToLocal = (
  userId: number,
  dashBoardName: string,
  dashBoardItems: DashBoardItemData[],
  globalAxisKey?: string,
  profileId?: number
) => {
  indexedDB.dashBoard.put(dataToProfile(
    {
      items: dashBoardItems,
      globalAxisKey
    },
    `${userId}-${dashBoardName}`,
    profileId
  ))
}

export const LoadFromLocal = (
  userId: number,
  dashBoardName: string,
  callBack: (data: DashBoardTable | null) => void
) => {
  indexedDB.dashBoard
    .where({
      boardId: `${userId}-${dashBoardName}`
    })
    .first()
    .then((data) => {
      callBack(data ? data : null)
    })
    .catch((reason) => {
      console.log(reason)
      callBack(null)
    })
}

export const LoadFromServerByProfileId = (
  apiAccess: ApiAccess,
  dashBoardName: string,
  profileId: number | undefined,
  callBack: (profile: DashBoardProfileResult | null) => void
) => {
  if (!profileId) {
    callBack(null)
    return
  }
  GetDashBoardProfile(dashBoardName, profileId, apiAccess)
    .then((response) => {
      callBack(response?.profileData ? response : null)
    })
    .catch((reason) => {
      console.log(reason)
      callBack(null)
    })
}

export const SaveToServer = (
  apiAccess: ApiAccess,
  dashBoardName: string,
  dashBoardItems: DashBoardItemData[],
  globalAxisKey?: string,
) => PostSelfUserProfile(
  apiAccess,
  `dashboard-${dashBoardName}`,
  {
    items: dashBoardItems,
    globalAxisKey
  }
)
.catch((reason) => {
  console.log('failed to profile save to server', reason)
})

export const LoadFromServer = (
  apiAccess: ApiAccess,
  dashBoardName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callBack: (profile: any | null) => void
) => GetSelfUserProfile(
  apiAccess,
  `dashboard-${dashBoardName}`
)
.catch(() => ({}))
.then((profile) => {
  if (!profile) return undefined
  callBack(profile)
})

export const profileToData = (data: DashBoardItem[] | DashBoardTable): DashBoardData => {
  const items = Array.isArray(data) ? data : data.items
  const globalAxisKey = Array.isArray(data) ? undefined : data.globalAxisKey
  const nextPosition = { x: 0, y: 0 }
  let maxHeight = 0
  return {
    items: items?.map((item, i) => {
      const width = (typeof item.width === 'number') ? item.width :
        item.width === 'small' ? 3 :
        item.width === 'midium' ? 4 :
        item.width === 'large' ? 6 :
        item.width === 'extra' ? 12 :
        item.size === 'wide' ? 12 :
        item.size === 'small' ? 3 :
        item.size === 'midium' ? 4 :
        item.size === 'large' ? 6 :
        item.size === 'extra' ? 12 : 200
      const height = (typeof item.height === 'number') ? item.height :
        item.width === 'small' ? 3 :
        item.width === 'midium' ? 4 :
        item.width === 'large' ? 6 :
        item.width === 'extra' ? 12 :
        item.size === 'wide' ? 3 :
        item.size === 'small' ? 3 :
        item.size === 'midium' ? 4 :
        item.size === 'large' ? 6 :
        item.size === 'extra' ? 12 : 1
      let x = 0, y = 0
      if (item.x === undefined || item.y === undefined) {
        x = nextPosition.x
        y = nextPosition.y
      } else {
        x = item.x
        y = item.y
      }
      nextPosition.x = x + width
      if (nextPosition.x >= 12) {
        nextPosition.x = 0
        nextPosition.y += maxHeight
        maxHeight = 0
      }
      if (maxHeight < height) {
        maxHeight = height
      }
      return {
        id: i + 1,
        width,height,
        x, y,
        title: item.title,
        graphType: item.graphType ?? 'horizonBar',
        options: item.options?.map(
          (opt) => ({
            id: opt.id,
            value: opt.value
          })
        )
      }
    }) ?? [],
    globalAxisKey
  }
}

export const dataToProfile = (data: DashBoardData, boardId?: string, profileId?: number): DashBoardTable => {
  return {
    boardId,
    profileId,
    items: data.items,
    globalAxisKey: data.globalAxisKey
  }
}
